module.exports = __webpack_public_path__ + "static/media/GripLines.2afd305a.svg";